import { getTopDomain } from './utils'
import Logger from './Log'

const Log = Logger.for('CarbonTracker')

export class CarbonTracker {
  constructor (zoneId) {
    this._zoneId = zoneId
    this._reqs = [] // list of bidders we made a request to
    this._bids = [] // { bidder, price, format }
    this._wins = [] // superunit can fill multiple divs not just single zone
  }

  request (bidder) {
    this._reqs.push(bidder)
  }

  bid (bid) {
    this._bids.push(bid)
  }

  bidWon (bid) {
    this._wins.push(bid)
  }

  _toMacro (bids) {
    const list = bids.map(bid => bid.bidder + ':' + bid.price)
    return '"' + list.join('|') + '"'
  }

  _winUrl (wb) {
    if (!wb) throw new Error('submitWin called with no bid!')

    let url = 'https://rp.adaptiveads.com/v1/rev/cpm/'
    url += wb ? wb.price : 0
    url += '?accountid=smrtb'
    url += '&divid=' + this._zoneId
    url += '&url=' + getTopDomain().replace('http://', '').replace('https://', '')
    url += '&wbidder=' + (wb ? wb.bidder : '')
    url += '&bidReqs=' + encodeURIComponent(this._toMacro(this._reqs.map(b => ({ bidder: b, price: 1 }))))
    url += '&bidResps=' + encodeURIComponent(this._toMacro(this._bids))
    url += '&asrc=superunit'
    url += '&mediaType=' + (wb ? wb.format : '')

    Log.debug('Post URL ' + url)
    console.log(this)

    return url
  }

  submit () {
    if (this._wins.length === 0) {
      Log.info('No cleared imps to report')
      return
    }

    Log.info('Skipping reporting carbon events')

    /*
    Promise.all(this._wins.map(win => ajax(this._winUrl(win))))
      .then(() => {
        Log.info('Successfully reported ' + this._wins.length + ' cleared impressions')
      }).catch(e => {
        Log.error('Error reporting cleared imps to carbon: ' + e.message)
      })
     */
  }
}
